<template>
	<router-view></router-view>
</template>
<script>
export default {
	name: 'page-not-found',
};
</script>


// WEBPACK FOOTER //
// src/pages/page-not-found.vue